export function roundMoney(amount, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.round((amount + Number.EPSILON) * factor) / factor;
}
export function convertAmount(amount, tasaCambio, round = true) {
    if (tasaCambio <= 0)
        return amount;
    const result = amount * tasaCambio;
    return round ? roundMoney(result) : result;
}
/**
 * Parses a money string in LATAM locale conventions.
 *
 * Accepted formats (es-LA):
 *   "1000"          -> 1000
 *   "1000.50"       -> 1000.5     (US-style decimal with dot)
 *   "1000,50"       -> 1000.5     (LATAM-style decimal with comma)
 *   "1.000,50"      -> 1000.5     (LATAM thousands + decimal)
 *   "1,000.50"      -> 1000.5     (US thousands + decimal)
 *   "" / "   "      -> 0
 *   "abc"           -> NaN        (caller decides how to handle)
 *   ",50"           -> 0.5
 *   "-1500,50"      -> -1500.5
 *
 * Heuristic:
 *   - Strip whitespace
 *   - If both `.` and `,` are present, the rightmost one is the decimal
 *     separator and the leftmost thousands separators are removed.
 *   - If only one separator is present, treat as decimal. Both `,` and `.`
 *     are accepted as decimal because LATAM users mix them in the same
 *     form when copy/pasting, especially across keyboards.
 *   - Negative sign allowed at start.
 */
export function parseMoney(input) {
    if (input == null)
        return 0;
    let s = String(input)
        .trim()
        .replace(/[\s\u00A0\u202F]/g, '');
    if (s.length === 0)
        return 0;
    const sign = s.startsWith('-') ? -1 : 1;
    if (sign === -1)
        s = s.slice(1);
    if (!/^[\d.,]+$/.test(s)) {
        return NaN;
    }
    const hasDot = s.includes('.');
    const hasComma = s.includes(',');
    let normalized = s;
    if (hasDot && hasComma) {
        // Rightmost is the decimal separator; the other is thousands
        const lastDot = s.lastIndexOf('.');
        const lastComma = s.lastIndexOf(',');
        if (lastDot > lastComma) {
            normalized = s.replace(/,/g, '');
        }
        else {
            normalized = s.replace(/\./g, '').replace(',', '.');
        }
    }
    else if (hasComma) {
        // Only comma — decimal
        normalized = s.replace(',', '.');
    }
    else if (hasDot) {
        // Only dot(s) — could be thousands separators ("1.000.000") or US decimal ("1000.50")
        const dotCount = (s.match(/\./g) || []).length;
        if (dotCount > 1 || /^\d+\.\d{3}$/.test(s)) {
            normalized = s.replace(/\./g, '');
        }
    }
    const n = Number(normalized);
    if (Number.isNaN(n))
        return NaN;
    return sign * n;
}
/**
 * Suma los `monto_base` de un desglose. Si una línea no trae
 * `monto_base` (caso: el frontend aún no convirtió), se ignora.
 */
export function sumDesglose(desglose) {
    let total = 0;
    for (const l of desglose) {
        if (typeof l.monto_base === 'number' && !Number.isNaN(l.monto_base)) {
            total += l.monto_base;
        }
    }
    return roundMoney(total);
}
//# sourceMappingURL=index.js.map